import React from "react";
import { Select } from "antd";
import { FormattedMessage, useIntl } from "react-intl";

const { Option } = Select;

const CommunityTemplatesOrderSelect = ({setOrderByDate, setOrderAlphabetically, setOrderAlphabeticallyReverse}) => {

  const intl = useIntl();

  const availableOrderOptions = [intl.formatMessage({id: "ask.pages.edit.lastPublish"}), "A-Z", "Z-A"];

  const onChangeOption = e => {
    if (e === "0"){
      setOrderByDate(true);
      setOrderAlphabetically(false);
      setOrderAlphabeticallyReverse(false);
    } else if (e === "1") {
      setOrderByDate(false);
      setOrderAlphabetically(true);
      setOrderAlphabeticallyReverse(false);
    } else {
      setOrderByDate(false);
      setOrderAlphabetically(false);
      setOrderAlphabeticallyReverse(true);
    }
  };

  const options = availableOrderOptions.map((opt, index) => {
    return <Option
      key={index}
    >
      {opt}
    </Option>;
  });

  return (
    <div className="askEdit-order-by-container">
      <div className="askEdit-order-by-description"><FormattedMessage id="ask.pages.edit.orderBy" /></div>
      <Select className="ask-edit-order-select" bordered={false} defaultValue={availableOrderOptions[0]} onChange={(e) => onChangeOption(e)}>
        {options}
      </Select>
    </div>
  );
};

export default CommunityTemplatesOrderSelect;